export const STATUS_LABELS = {
  in_attesa: "In attesa",
  in_corso: "In corso",
  completato: "Completato",
  scarto_bloccato: "Scarto / Bloccato",
};

export const STATUS_CLASSES = {
  in_attesa: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  in_corso: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  completato: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  scarto_bloccato: "bg-rose-500/10 text-rose-400 border-rose-500/30",
};

export const STATUS_LIST = ["in_attesa", "in_corso", "completato", "scarto_bloccato"];

export function formatMinutes(mins) {
  const m = Number(mins) || 0;
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const rem = Math.round(m % 60);
  return rem ? `${h}h ${rem}m` : `${h}h`;
}
